import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-print-operations/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignFilter !== undefined) {
        body = params.campaignFilter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaigns.paramsOrder = [{ type: 'body', paramName: 'campaignFilter' }];
export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-print-operations/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.publicationDateFrom
            : (params.publicationDateFrom ?? queryDefaults?.['publicationDateFrom']);
        if (value !== undefined) {
            urlParams.append('publicationDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.publicationDateTo
            : (params.publicationDateTo ?? queryDefaults?.['publicationDateTo']);
        if (value !== undefined) {
            urlParams.append('publicationDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignPositionStatus
            : (params.campaignPositionStatus ?? queryDefaults?.['campaignPositionStatus']);
        if (value !== undefined) {
            urlParams.append('campaignPositionStatus', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.notSentPhysicalProof
            : (params.notSentPhysicalProof ?? queryDefaults?.['notSentPhysicalProof']);
        if (value !== undefined) {
            urlParams.append('notSentPhysicalProof', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.adMediumId : (params.adMediumId ?? queryDefaults?.['adMediumId']);
        if (value !== undefined) {
            urlParams.append('adMediumId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getPublications = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-print-operations/publications/get';
    const pathInternal = '/api/publications/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublications.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const getPublication = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publicationId === undefined) {
        throw new Error('Missing required parameter: publicationId');
    }
    const path = '/api/ws-print-operations/publications/{publicationId}'.replace('{publicationId}', params.publicationId?.toString());
    const pathInternal = '/api/publications/{publicationId}'.replace('{publicationId}', params.publicationId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublication.paramsOrder = [{ type: 'parameters' }];
export const updatePublication = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publicationId === undefined) {
        throw new Error('Missing required parameter: publicationId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-print-operations/publications/{publicationId}'.replace('{publicationId}', params.publicationId?.toString());
    const pathInternal = '/api/publications/{publicationId}'.replace('{publicationId}', params.publicationId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePublication.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionId === undefined) {
        throw new Error('Missing required parameter: positionId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/{positionId}'.replace('{positionId}', params.positionId?.toString());
    const pathInternal = '/api/campaigns/campaign-positions/{positionId}'.replace('{positionId}', params.positionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignPosition.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const changeCampaignPositionsStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.changeStatusForm === undefined) {
        throw new Error('Missing required body: changeStatusForm');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/change-status';
    const pathInternal = '/api/campaigns/campaign-positions/change-status';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.changeStatusForm !== undefined) {
        body = params.changeStatusForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changeCampaignPositionsStatus.paramsOrder = [{ type: 'body', paramName: 'changeStatusForm' }];
export const getCampaignPositionsStatusByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionIds === undefined) {
        throw new Error('Missing required body: positionIds');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/get-status';
    const pathInternal = '/api/campaigns/campaign-positions/get-status';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionIds !== undefined) {
        body = params.positionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsStatusByIds.paramsOrder = [{ type: 'body', paramName: 'positionIds' }];
export const unhideCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/unhide';
    const pathInternal = '/api/campaigns/campaign-positions/unhide';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
unhideCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const pushToExternalSystem = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/push-to-external-system';
    const pathInternal = '/api/campaigns/campaign-positions/push-to-external-system';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
pushToExternalSystem.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const changeMotiveStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.motiveStatusForm === undefined) {
        throw new Error('Missing required body: motiveStatusForm');
    }
    const path = '/api/ws-print-operations/campaigns/{campaignId}/change-motive-status'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/change-motive-status'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.motiveStatusForm !== undefined) {
        body = params.motiveStatusForm;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
changeMotiveStatus.paramsOrder = [{ type: 'body', paramName: 'motiveStatusForm' }, { type: 'parameters' }];
export const changeCampaignPositionMotiveStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.motiveStatusForm === undefined) {
        throw new Error('Missing required body: motiveStatusForm');
    }
    const path = '/api/ws-print-operations/campaign-positions/{campaignPositionId}/change-motive-status'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/change-motive-status'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.motiveStatusForm !== undefined) {
        body = params.motiveStatusForm;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
changeCampaignPositionMotiveStatus.paramsOrder = [
    { type: 'body', paramName: 'motiveStatusForm' },
    { type: 'parameters' },
];
export const updateCreativeCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.motiveStatus === undefined) {
        throw new Error('Missing required parameter: motiveStatus');
    }
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-print-operations/creatives/{creativeId}/update-campaign-positions/{motiveStatus}'
        .replace('{creativeId}', params.creativeId?.toString())
        .replace('{motiveStatus}', params.motiveStatus?.toString());
    const pathInternal = '/api/creatives/{creativeId}/update-campaign-positions/{motiveStatus}'
        .replace('{creativeId}', params.creativeId?.toString())
        .replace('{motiveStatus}', params.motiveStatus?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCreativeCampaignPositions.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionIds' },
    { type: 'parameters' },
];
export const requestCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativesRequestForm === undefined) {
        throw new Error('Missing required body: creativesRequestForm');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-print-operations/campaigns/{campaignId}/campaign-positions/request-creatives'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/request-creatives'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativesRequestForm !== undefined) {
        body = params.creativesRequestForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
requestCreatives.paramsOrder = [{ type: 'body', paramName: 'creativesRequestForm' }, { type: 'parameters' }];
export const generateEmailForm = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.emailForm === undefined) {
        throw new Error('Missing required body: emailForm');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-print-operations/campaigns/{campaignId}/emails/generate'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/emails/generate'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.emailForm !== undefined) {
        body = params.emailForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateEmailForm.paramsOrder = [{ type: 'body', paramName: 'emailForm' }, { type: 'parameters' }];
export const sendProofs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.sendProofsForm === undefined) {
        throw new Error('Missing required body: sendProofsForm');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/send-proofs';
    const pathInternal = '/api/campaigns/campaign-positions/send-proofs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.sendProofsForm !== undefined) {
        body = params.sendProofsForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
sendProofs.paramsOrder = [{ type: 'body', paramName: 'sendProofsForm' }];
export const sendAllProofs = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-print-operations/campaigns/campaign-positions/send-proofs/all';
    const pathInternal = '/api/campaigns/campaign-positions/send-proofs/all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
sendAllProofs.paramsOrder = [];
export const checkAllProofsSentStatus = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-print-operations/campaigns/campaign-positions/send-proofs/all';
    const pathInternal = '/api/campaigns/campaign-positions/send-proofs/all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkAllProofsSentStatus.paramsOrder = [];
export const sendProofEmails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.sendProofsForm === undefined) {
        throw new Error('Missing required body: sendProofsForm');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/send-proof-emails';
    const pathInternal = '/api/campaigns/campaign-positions/send-proof-emails';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.sendProofsForm !== undefined) {
        body = params.sendProofsForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
sendProofEmails.paramsOrder = [{ type: 'body', paramName: 'sendProofsForm' }];
/** Download labels */ export const downloadLabels = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.reference === undefined) {
        throw new Error('Missing required parameter: reference');
    }
    const path = '/api/ws-print-operations/labels/download/{reference}'.replace('{reference}', params.reference?.toString());
    const pathInternal = '/api/labels/download/{reference}'.replace('{reference}', params.reference?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: {
            200: 'json',
            204: 'void',
        },
        requestType: 'json',
    });
};
downloadLabels.paramsOrder = [{ type: 'parameters' }];
/** Generate labels and return file ID for download from ws-file-uploader */ export const generateLabels = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-print-operations/labels/generate';
    const pathInternal = '/api/labels/generate';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.onlyPreview : (params.onlyPreview ?? queryDefaults?.['onlyPreview']);
        if (value !== undefined) {
            urlParams.append('onlyPreview', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isMsWord : (params.isMsWord ?? queryDefaults?.['isMsWord']);
        if (value !== undefined) {
            urlParams.append('isMsWord', value.toString());
        }
    }
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateLabels.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }, { type: 'parameters' }];
/** Uploads new publication in Base64 format. */ export const uploadPublicationFileUI = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publicationId === undefined) {
        throw new Error('Missing required parameter: publicationId');
    }
    if (params.encodedFileName === undefined) {
        throw new Error('Missing required parameter: encodedFileName');
    }
    const path = '/api/ws-print-operations/publications/{publicationId}/upload/ui'.replace('{publicationId}', params.publicationId?.toString());
    const pathInternal = '/api/publications/{publicationId}/upload/ui'.replace('{publicationId}', params.publicationId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.encodedFileName !== undefined) {
        urlParams.append('encodedFileName', params.encodedFileName.toString());
    }
    if (params.content !== undefined) {
        formData.append('content', toCorrectFormDataValue(params.content));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadPublicationFileUI.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Returns the Attachment in Base64 format. */ export const downloadPublicationDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publicationId === undefined) {
        throw new Error('Missing required parameter: publicationId');
    }
    const path = '/api/ws-print-operations/publications/{publicationId}/file'.replace('{publicationId}', params.publicationId?.toString());
    const pathInternal = '/api/publications/{publicationId}/file'.replace('{publicationId}', params.publicationId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPublicationDocument.paramsOrder = [{ type: 'parameters' }];
/** Delete publication file. */ export const deletePublicationDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publicationId === undefined) {
        throw new Error('Missing required parameter: publicationId');
    }
    const path = '/api/ws-print-operations/publications/{publicationId}/file'.replace('{publicationId}', params.publicationId?.toString());
    const pathInternal = '/api/publications/{publicationId}/file'.replace('{publicationId}', params.publicationId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deletePublicationDocument.paramsOrder = [{ type: 'parameters' }];
/** Uploads new positions proof in Base64 format. */ export const uploadPositionsProof = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionIds === undefined) {
        throw new Error('Missing required parameter: positionIds');
    }
    if (params.encodedFileName === undefined) {
        throw new Error('Missing required parameter: encodedFileName');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/proof/upload/ui';
    const pathInternal = '/api/campaigns/campaign-positions/proof/upload/ui';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionIds !== undefined) {
        urlParams.append('positionIds', params.positionIds.toString());
    }
    if (params.encodedFileName !== undefined) {
        urlParams.append('encodedFileName', params.encodedFileName.toString());
    }
    if (params.content !== undefined) {
        formData.append('content', toCorrectFormDataValue(params.content));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadPositionsProof.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Returns the Attachment in Base64 format. */ export const downloadPositionProofDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionId === undefined) {
        throw new Error('Missing required parameter: positionId');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/{positionId}/proof/file'.replace('{positionId}', params.positionId?.toString());
    const pathInternal = '/api/campaigns/campaign-positions/{positionId}/proof/file'.replace('{positionId}', params.positionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPositionProofDocument.paramsOrder = [{ type: 'parameters' }];
/** Delete position proof file. */ export const deletePositionsProofDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionIds === undefined) {
        throw new Error('Missing required body: positionIds');
    }
    const path = '/api/ws-print-operations/campaigns/campaign-positions/proof/file/delete';
    const pathInternal = '/api/campaigns/campaign-positions/proof/file/delete';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionIds !== undefined) {
        body = params.positionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deletePositionsProofDocument.paramsOrder = [{ type: 'body', paramName: 'positionIds' }];
export const getCampaignPositionCiclon = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-print-operations/campaign-positions/{id}/ciclon'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}/ciclon'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionCiclon.paramsOrder = [{ type: 'parameters' }];
export const getBatchNonMigratedPublications = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-print-operations/publications/batch/non-migrated';
    const pathInternal = '/api/publications/batch/non-migrated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchNonMigratedPublications.paramsOrder = [{ type: 'parameters' }];
/** Update file IDs for publications after batch migration */ export const batchUpdatePublicationFileIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-print-operations/publications/batch/update-file-ids';
    const pathInternal = '/api/publications/batch/update-file-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
batchUpdatePublicationFileIds.paramsOrder = [{ type: 'body', paramName: 'forms' }];
export const getBatchNonMigratedPositionProofs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-print-operations/campaign-positions/batch/non-migrated-proofs';
    const pathInternal = '/api/campaign-positions/batch/non-migrated-proofs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchNonMigratedPositionProofs.paramsOrder = [{ type: 'parameters' }];
/** Update file IDs for position proofs after batch migration */ export const batchUpdatePositionProofFileIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-print-operations/campaign-positions/batch/update-proof-file-ids';
    const pathInternal = '/api/campaign-positions/batch/update-proof-file-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
batchUpdatePositionProofFileIds.paramsOrder = [{ type: 'body', paramName: 'forms' }];
export const getBatchNonMigratedPositionLabels = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-print-operations/campaign-positions/batch/non-migrated-labels';
    const pathInternal = '/api/campaign-positions/batch/non-migrated-labels';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchNonMigratedPositionLabels.paramsOrder = [{ type: 'parameters' }];
/** Update file IDs for position labels after batch migration */ export const batchUpdatePositionLabelFileIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-print-operations/campaign-positions/batch/update-label-file-ids';
    const pathInternal = '/api/campaign-positions/batch/update-label-file-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
batchUpdatePositionLabelFileIds.paramsOrder = [{ type: 'body', paramName: 'forms' }];
export * from './types';
export * from './constants';
